module.exports = __webpack_public_path__ + "assets/images/CNY50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CNY50.png
// module id = 1347
// module chunks = 1